<div class="card bg-light mb-3">
  <span
    [ngClass]="'card-body bulk-edit-description'"
    [innerHtml]="'tkey;admin.sitemacman.modal.bulk.edit.description' | escapeHtml"
  ></span>
</div>
<ziro-radio [fieldId]="'accessLevel'"></ziro-radio>
<ziro-filter-input
  (filterChanged)="onChanged($event)"
  [value]="resultFilter"
  [dataAutomation]="'site-based-helpdesk-filter'"
></ziro-filter-input>
@if (authorization === siteClusterSelection.SITES) {
  <div class="custom-table">
    @for (item of filteredAuthorizedSitesOpts; track item; let i = $index) {
      <div>
        @if (isClusterForAuthorizedSite(i, item.cluster)) {
          <div class="col-12 text-muted custom-table__header">
            {{ item.cluster }}
          </div>
        }
        <div class="col-12 form-check custom-table__row">
          <input
            type="checkbox"
            name="'{{ item.cluster }}'"
            id="select-site-{{ item.site }}"
            class="form-check-input"
            [checked]="isSiteSelectedForAllUsers(item.site) || selectedSites.includes(item.site)"
            [ngClass]="{ 'indeterminate-input': isIndeterminateSite(item.site) }"
            (change)="updateSiteSelection(item.site, $event)"
          />
          <label for="select-site-{{ item.site }}" class="form-check-label">{{ item.site }}</label>
        </div>
      </div>
    }
  </div>
}
@if (authorization === siteClusterSelection.CLUSTERS) {
  <div class="custom-table">
    @for (item of filteredAuthorizedClusterOpts; track item) {
      <div class="d-flex">
        <div class="col-12 form-check custom-table__row">
          <input
            type="checkbox"
            class="form-check-input"
            id="select-cluster-{{ item.name }}"
            [checked]="isClusterSelectedForAllUsers(item.name)"
            [ngClass]="{ 'indeterminate-input': isIndeterminateCluster(item.name) }"
            (change)="updateClusterSelection(item.name, $event)"
          />
          <label for="select-cluster-{{ item.name }}" class="form-check-label">{{ item.name }}</label>
        </div>
      </div>
    }
  </div>
}
<div class="checkbox-container">
  <ziro-checkbox [fieldId]="'readAccessToControlEnabled'"></ziro-checkbox>
  <ziro-checkbox [fieldId]="'isAccessDisabled'"></ziro-checkbox>
</div>
